import { formatNumberWithSpaces } from "utils/formatNumberWithSpaces";
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "antd";

const { Meta } = Card;
import CardTitle from "components/CardTitle";
import CardLayout from "components/CardLayout";
import { FaPeopleGroup } from "react-icons/fa6";

interface PendingPaymentsProps {
  totalSaleDocuments?: number | string;
  totalReturns?: number | string;
  totalValue?: number | string;
  subtotal?: number | string;
  currencyCode: ID;
  decimalPlaces: number;
  loading: boolean;
}

export default function PendingPayments(props: PendingPaymentsProps): React.ReactElement {
  const {
    totalSaleDocuments,
    currencyCode,
    decimalPlaces,
    totalReturns,
    totalValue,
    subtotal,
    loading,
  } = props;

  const { t } = useTranslation();

  const formattedTotalValue = formatNumberWithSpaces(
    Number(totalValue ?? 0).toFixed(decimalPlaces),
  );
  const formattedSubTotalValue = formatNumberWithSpaces(
    Number(subtotal ?? 0).toFixed(decimalPlaces),
  );

  return (
    <CardLayout
      className="outstanding-card"
      loading={loading}
      tooltipText={t("Only validated documents are taken into account")}
      title={<CardTitle icon={<FaPeopleGroup />} title={t("Outstanding clients")} />}
    >
      <Meta
        description={
          <>
            <Row gutter={[16, 0]} justify="start" className="card-values">
              <Col span={24} className="card-main-value">
                <strong>
                  {formattedTotalValue} {currencyCode}{" "}
                </strong>
                <span className="tva-type-name">TTC</span>
              </Col>
              <Col className="card-detail-row">
                <div className="card-detail-item">
                  <span className="card-detail-label">{t("Invoices")}:</span>
                  <span className="card-detail-value">
                    {formatNumberWithSpaces(totalSaleDocuments) ?? 0}
                  </span>
                </div>
              </Col>
              <Col className="card-detail-row">
                <div className="card-detail-item">
                  <span className="card-detail-label">{t("Returns")}:</span>
                  <span className="card-detail-value">
                    {formatNumberWithSpaces(totalReturns) ?? 0}
                  </span>
                </div>
              </Col>
              <Col className="card-detail-row">
                <div className="card-detail-item">
                  <span className="card-detail-label">{t("Sub-total")}:</span>
                  <span className="card-detail-value">
                    <strong>
                      {formattedSubTotalValue} {currencyCode}
                    </strong>
                  </span>
                </div>
              </Col>
            </Row>
          </>
        }
      />
    </CardLayout>
  );
}
